import Vue from 'vue'
import VueRouter from 'vue-router'

import Home from '@/views/Home';

//首页
import HomeIndex from '@/views/home/index'
import HomeRss from '@/views/home/rss'
import HomeRss2 from '@/views/home/rss2'

import HomeNew from '@/views/index'

import BidsDetail from '@/views/bids/detail';

//搜索
import SearchIndex from '@/views/search/index'

//个人中心
import MeIndex from '@/views/me/index'
import Favorite from '@/views/me/favorite'

//支付
import OrderPay from '@/views/order/pay';
import payDone from "@/views/order/payDone";

//vip
import VipIndex from '@/views/vip/index';

//基础
import Login from '@/views/site/login';
import Register from '@/views/site/register';
import About from '@/views/site/about';

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
  return originalPush.call(this, location).catch(err => err)
}

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    // redirect:'/home',
    children:[
      {
        path: '/',
        name: 'HomeNew',
        component: HomeNew
      },
      {
        path: '/home',
        name: 'HomeIndex',
        component: HomeIndex
      },
      {
        path: '/search',
        name: 'SearchIndex',
        component: SearchIndex
      },
      {
        path: '/me',
        name: 'MeIndex',
        component: MeIndex
      },
    ]
  },
  {
    path: '/rss',
    name: 'HomeRss',
    component: HomeRss
  },
  {
    path: '/rss2',
    name: 'HomeRss2',
    component: HomeRss2
  },
  {
    path: '/bids/detail/:id',
    name: 'BidsDetail',
    component: BidsDetail
  },
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/register',
    name: 'Register',
    component: Register
  },
  {
    path: '/order/pay',
    name: 'OrderPay',
    component: OrderPay
  },
  {
    path: '/order/paydone',
    name: 'payDone',
    component: payDone
  },
  {
    path: '/vip',
    name: 'VipIndex',
    component: VipIndex
  },
  {
    path: '/about',
    name: 'About',
    component: About
  },
  {
    path:'/me/favorite',
    name:'Favorite',
    component: Favorite
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
